module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label-tag', {
    attrs: {
      "tagArray": [_vm.$t('vocabulary_mission')]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-5",
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('vocabulary-form')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d456e58!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/vr/VocabularyMission.vue
// module id = 768
// module chunks = 3